export const ALERTAS_GENERICAS = {
  CAMPOS_REQUERIDOS: "Favor completar los campos requeridos.",
  CAMPO_REQUERIDO: "Este campo es requerido",
  CORREO_INVALIDO: "Ingresa un correo electrónico válido",
  TELEFONO_INVALIDO: "Ingrese un teléfono válido",
  FECHA_DESDE_HASTA_INVALIDA: "La fecha desde debe ser menor que la fecha hasta.",
  SESION_ACTIVA: "Usted ya tiene una sesión activa con el pss: ",
  CODIGO_COBERTURA_REQUERIDO: "Favor completar el código de la cobertura.",
  CAMPOS_PSS_REQUERIDOS: "Favor completar tipo de pss y código del pss.",
};
